import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const Hba1cInputPage = lazy(() => import("./Hba1cInputPage"));

const Hba1cInputPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <Hba1cInputPage />
    </Suspense>
  );
};

export default Hba1cInputPageLazy;
